import {
  API_BASE_URL,
  STRIPE_PAYMENT_LINK_FREE_TRIAL,
  STRIPE_PAYMENT_LINK_NO_FREE_TRIAL,
  fetchAuthenticated,
} from "../utils/config";
import { useAppData } from "../context/AppDataContext";

export function useSubscription() {
  const { isSubscribed, user, loading } = useAppData();

  const manageSubscription = async () => {
    try {
      // 1. If currently active or trialing, manage via Stripe Portal
      if (isSubscribed) {
        const res = await fetchAuthenticated(
          `${API_BASE_URL}/userProfile/updateSubscription`
        );
        const data = await res.json();
        window.location.href = data.URL;
        return;
      }

      // 2. Identify returning vs. new users
      const status = user?.subscriptionStatus?.toLowerCase() || "";
      const encodedEmail = encodeURIComponent(user?.email || "");

      // Check for specific "Returning User" indicators
      const isReturningUser = status === "canceled" || status === "deactivated" || status === "unpaid";

      // 3. Select the correct link
      const targetLink = isReturningUser 
        ? STRIPE_PAYMENT_LINK_NO_FREE_TRIAL 
        : STRIPE_PAYMENT_LINK_FREE_TRIAL;

      window.location.href = `${targetLink}?prefilled_email=${encodedEmail}`;

    } catch (err) {
      console.error("Subscription action failed", err);
      alert("Unable to manage subscription.");
    }
  };

  return {
    isSubscribed,
    subscriptionStatus: user?.subscriptionStatus,
    loading,
    manageSubscription,
  };
}